export default "__VITE_ASSET__DEnNxh3K__"